export const TENANT_ENVIRONMENT_REQUEST = "TENANT_ENVIRONMENT_REQUEST"
export const TENANT_ENVIRONMENT_RECEIVE = "TENANT_ENVIRONMENT_RECEIVE"
export const TENANT_ENVIRONMENT_FAILURE = "TENANT_ENVIRONMENT_FAILURE"
